export default __webpack_public_path__ + "static/media/icon-edit.233d1510.svg";